module.exports = __webpack_public_path__ + "static/img/016.b827a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/016.png
// module id = rek9
// module chunks = 0